.itemAnimating {
  animation: flyUp 1000ms ease-in-out forwards;
}

@keyframes flyUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-800px);
  }
}
